module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.0e518f4b.mp3";